import { render } from "./PenjelasanDokumen.vue?vue&type=template&id=1fcf6a7c&scoped=true"
import script from "./PenjelasanDokumen.vue?vue&type=script&lang=js"
export * from "./PenjelasanDokumen.vue?vue&type=script&lang=js"

import "./PenjelasanDokumen.vue?vue&type=style&index=0&id=1fcf6a7c&scoped=true&lang=css"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fcf6a7c"]])

export default __exports__